// react router dom
import {
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";

import { NextUIProvider } from "@nextui-org/react";
import HomePage from "./Pages/HomePage";
import ProductsPage from "./Pages/ProductsPage";
import ContactPage from "./Pages/ContactPage";
import AboutPage from "./Pages/AboutPage";
import ApiProvider from "./Context/ApiProvider";
import i18n from "./i18n";
import { useEffect } from "react";
import BlogPage from "./Pages/BlogPage";
import SingleProductPage from "./Pages/ProductDetailPage";
import BlogDetailPage from "./Pages/BlogDetailPage";
import Factory from "./Components/Factory";
import HeadOffice from "./Components/HeadOffice";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const lng = localStorage.getItem("lng");

  useEffect(() => {
    const path = location.pathname;
    let newLanguage = lng;
    let newDir = lng === "fa" || lng === "ar" ? "rtl" : "ltr";

    if (path.includes("/fa")) {
      newLanguage = "fa";
      newDir = "rtl";
    } else if (path.includes("/ar")) {
      newLanguage = "ar";
      newDir = "rtl";
    } else if (path.includes("/ru")) {
      newLanguage = "ru";
      newDir = "ltr";
    } else if (path.includes("/en")) {
      newLanguage = "en";
      newDir = "ltr";
    }

    if (lng !== newLanguage) {
      localStorage.setItem("lng", newLanguage);
      i18n.changeLanguage(newLanguage);
      document.documentElement.setAttribute("dir", newDir);
    }
  }, [location.pathname, lng]);

  useEffect(() => {
    const dir = lng === "fa" || lng === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    i18n.changeLanguage(lng);
  }, [lng]);

  return (
    <ApiProvider>
      <NextUIProvider navigate={navigate}>
        <Routes>
          <Route path="/:lng" element={<HomePage />} />
          <Route path="/:lng/products" element={<ProductsPage />} />
          <Route path="/:lng/contact" element={<ContactPage />} />
          <Route path="/:lng/contact/head-office" element={<HeadOffice />} />
          <Route path="/:lng/contact/factory" element={<Factory />} />
          <Route path="/:lng/about" element={<AboutPage />} />
          <Route path="/:lng/blog" element={<BlogPage />} />
          <Route path="/:lng/blog-detail/:id" element={<BlogDetailPage />} />
          <Route
            path="/:lng/product-detail/:id"
            element={<SingleProductPage />}
          />

          <Route
            path="/products"
            element={<Navigate to={`/${lng}/products`} />}
          />
          <Route
            path="/contact"
            element={<Navigate to={`/${lng}/contact`} />}
          />
          <Route
            path="/contact/head-office"
            element={<Navigate to={`/${lng}/contact/head-office`} />}
          />
          <Route
            path="/contact/factory"
            element={<Navigate to={`/${lng}/contact/factory`} />}
          />
          <Route path="/about" element={<Navigate to={`/${lng}/about`} />} />
          <Route path="/blog" element={<Navigate to={`/${lng}/blog`} />} />
          <Route
            path="/product-detail/:id"
            element={<Navigate to={`/${lng}/product-detail/:id`} />}
          />
          <Route
            path="/blog-detail/:id"
            element={<Navigate to={`/${lng}/blog-detail/:id`} />}
          />

          <Route path="*" element={<Navigate to={`/${lng}`} />} />
        </Routes>
      </NextUIProvider>
    </ApiProvider>
  );
}

export default App;
